<template>
  <div
    class="grid gap-1 text-[14px] font-medium"
    :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
  >
    <span
      v-if="party && party.company"
      class="font-semibold"
      :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
      >{{ party.company }}</span
    >
    <span v-if="party && party.contact_name">{{ party.contact_name }}</span>
    <span
      v-for="(item, index) in (party && party.details) || []"
      :key="index"
      >{{ item }}</span
    >
    <span v-if="party && party.phone">{{ party.phone }}</span>
    <a
      v-if="party && party.email"
      :href="`mailto:${party.email}`"
      class="font-semibold underline hover:text-primary-100"
      :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
      >{{ party.email }}</a
    >
  </div>
</template>

<script>
export default {
  name: "PartyCell",
  props: {
    party: { type: Object, default: () => ({}) },
    mode: { type: String, default: "light" },
  },
};
</script>
